import { InclusionFilter } from "../../../legacy/types/companyFilter";
import { EXPORT_INCLUSION_TYPES } from "../types";
import { useTaxonomyContext } from "../../../contexts/Taxonomy/TaxonomyContext";

const DEFAULT_FAI_EXPORT_FILTER_PARAMS = {
  departmentIds: [],
  roleIds: [],
  includeDecisionMakersAndInfluencersOnly: false,
};

export const useFaiExportFilterParams = (
  faiInclusion: EXPORT_INCLUSION_TYPES,
  productsFilter: InclusionFilter[],
  includeDecisionMakersAndInfluencersOnly: boolean
) => {
  const { faiDepartmentRolesMap } = useTaxonomyContext();

  const canIncludeDecisionMakersAndInfluencersOnly = [
    EXPORT_INCLUSION_TYPES.ALL,
    EXPORT_INCLUSION_TYPES.SELECTED,
  ].includes(faiInclusion);

  // Return default params for NONE, ALL, and SELECTED inclusion types
  if (faiInclusion !== EXPORT_INCLUSION_TYPES.FILTERS) {
    // For ALL and SELECTED, we still need to include the decision makers flag if it's checked
    if (
      canIncludeDecisionMakersAndInfluencersOnly &&
      includeDecisionMakersAndInfluencersOnly
    ) {
      return {
        ...DEFAULT_FAI_EXPORT_FILTER_PARAMS,
        includeDecisionMakersAndInfluencersOnly: true,
      };
    }
    return DEFAULT_FAI_EXPORT_FILTER_PARAMS;
  }

  const finalDeptIds: string[] = [];
  const allRoleIds: string[] = [];

  productsFilter?.forEach((product) => {
    // Process departments
    (product.departmentIds || []).forEach((deptId) => {
      const deptRoles = faiDepartmentRolesMap.get(deptId);

      if (!deptRoles || deptRoles.length === 0) {
        // Department has no roles - keep it in departmentIds
        finalDeptIds.push(deptId);
      } else {
        // Department has roles - add only its roles, not the department
        allRoleIds.push(...deptRoles);
      }
    });

    // Add explicitly selected roles
    allRoleIds.push(...(product.roleIds || []));
  });

  // Remove duplicates
  const departmentIds = [...new Set(finalDeptIds)];
  const roleIds = [...new Set(allRoleIds)];

  return {
    departmentIds,
    roleIds,
    includeDecisionMakersAndInfluencersOnly,
  };
};
